<template>
  <section class="hero is-default is-bold">
    <div class="hero-body">
      <div class="container">
        <action-view-common
          v-if="entity && action"
          :action="action"
          :entity="entity"
          :generateMailTo="generateMailTo"
          :withQuota="false"
          :quota="0"
          :maxQuota="0"
        >
        </action-view-common>
      </div>
    </div>
  </section>
</template>

<script>
import transitionService from '@/services/transitionService.js'
import { Background } from '@/mixins/background.js'

import { PublicAction } from '@/models/transition/transition.js'
import { axiosRedirectError } from '@/router/utils'

export default {
  name: 'ActionView',
  props: {},
  components: {
    'action-view-common': () =>
      import('@/components/transition/ActionViewCommon.vue')
  },
  mixins: [Background],
  data: function () {
    return {
      erreur: null,
      action: null,
      quota: 0,
      maxQuota: 0,
      entity: null
    }
  },
  watch: {},
  computed: {
    actionId: function () {
      return this.$route.params.actionId
    }
  },
  methods: {
    generateMailTo (entity, action) {
      if (!entity) {
        return ''
      }
      if (!action) {
        return ''
      }
      let mailTo = entity.referent.email
      let subject = `[labos1point5] Action:  ${action.title}`
      // NOTE thunderbird supports html-body
      return `mailto:${mailTo}?subject=${subject}`
    }
  },
  mounted () {
    this.bgUI(
      async () => {
        let data = await transitionService.getOnePublishedAction(this.actionId)
        this.action = PublicAction.fromDatabase(data)
        this.entity = this.action.entity
      },
      undefined,
      axiosRedirectError
    )
  }
}
</script>
